export const GET_MODULES = 'Admin/GET_MODULES';
export const GET_CATEGORIES = 'Admin/GET_CATEGORIES';

export const USER_SEARCH_FORMAT = {
  public: 1,
  profile: 2,
  manage: 3,
  username: 4,
};



// WEBPACK FOOTER //
// ./src/routes/Admin/constants.ts